module.exports = __webpack_public_path__ + "static/img/29.51c632b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/29.png
// module id = HXSA
// module chunks = 1